<template></template>

<script>
/*

    props
    -----

    versionId - the version id
    masterOptionValueId - the id of the master value
    optionValueId - the id of the version value
    propertyName - the name of the property to be updated
    optionId - the option id ... needed when creating a new option for versions

    methods
    -------

    handleNewValue(newValue:String)

    events
    ------

    in-progress: a call has been made
    success: the call is complete. success
    error: the call is complete. with error

*/

import axios from 'axios';

let base_url = window.location.protocol + "//" + window.location.host;
export default {
    name: 'option-values-api-handler',
    props: {
        versionId: String,
        masterOptionValueId: Number,
        versionOptionValueId: Number,
        propertyName:String,
        optionId: Number,
    },
    data() {
        return {};
    },
    methods: {
        handleNewValueWithSync(newValue) {
            this.saveNewValue(newValue, true);
        },
        handleNewValue(newValue) {
            this.saveNewValue(newValue, false);
        },
        saveNewValue(newValue, withSync) {
            let adjustedVersionOptionValueid = this.versionOptionValueId;

            //if the version being updated is '0' then the option being updated is the master. Which means the
            //version option value id should be the master option value id
            if (this.versionId == '0') {
                adjustedVersionOptionValueid = this.masterOptionValueId;
            }

            if (this.versionId !== '0' && this.versionOptionValueId == -1) {
                //this option value doesn't exist yet ... need to create.
                this.$emit('in-progress');

                let nLabel = '';
                let nValue = '';
                if (this.propertyName == 'label') {
                    nLabel = newValue;
                } else {
                    nValue = newValue;
                }

                axios.post(base_url + '/pimapi/options/'+this.optionId+'/version/' + this.versionId + '/value', {
                    'label': nLabel,
                    'value': nValue,
                    'masterOptionValueId': this.masterOptionValueId,
                })
                .then((response) => {
                    this.$emit('success', response);
                })
                .catch((error) => {
                    this.$emit('error', error);
                });

            } else {
                this.$emit('in-progress');

                //update value (put)
                axios.put(base_url + '/pimapi/options/master/' + this.masterOptionValueId + '/value/' + adjustedVersionOptionValueid + '/version/' + this.versionId, {
                    "property_name": this.propertyName,
                    "new_value": newValue,
                    "sync": withSync,
                })
                .then((response) => {
                    this.$emit('success', response);
                })
                .catch((error) => {
                    this.$emit('error', error);
                });
            }
        }

    }
}
</script>

<style>

</style>